import FieldSearch from './fieldSearch';

export default FieldSearch.extend({

  filter(field, value, model) {
    let regex;

    try {
      regex = new RegExp(`.*(${value}).*`, 'i');
    } catch (e) {
      return false;
    }

    field = this.field || field; // property overrides

    const val = model.get(field);

    if (val && val.search) {
      return model.get(field).search(regex) > -1;
    }

    if (typeof model.get(field) === 'number') {
      return model.get(field) === +value;
    }

    return model.get(field) === value;
  }
});
